import routes from "@/router";
const _import = require('@/router/_import_' + process.env.NODE_ENV)

/**
 * 根据路由匹配地址
 * @param {*} data 路由数据
 * @param {*} base 路由前缀
 * @param {*} options 粗略的配置项
 */
function routeMatch(data: any, base: string, options: any = {
    url: 'path',
    name: 'name',
    id: "id",
    permissions: 'permissions',
    component: 'component'
}) {
    if (!Array.isArray(data)) return [];
    // 创建路由盒子
    let routerBox = routes;
    // 将菜单数据处理为一维函数 如果有多级菜单
    let menu = flattenDeep(data, 'children');

    // 遍历处理路由
    menu.forEach((item: any) => {
        if (!item[options.url]) return;
        let _url = item[options.url];
        try {
            let routerItem: any = {};
            if (item.component) {
                routerItem = {
                    path: _url,
                    name: item[options.name],
                    component: _import(item[options.component])
                };
            } else {
                routerItem = {
                    path: _url,
                    name: item[options.name] || item[options.id],
                    component: {
                        render: (h: any) => h('router-view')
                    }
                };
            }
            routerBox.push(routerItem);
        } catch (err) {
            item[options.url] = '/error'
        }
    });
    return routerBox;
}

/**
 * 将树形数据向下递归为一维数组
 * @param {*} arr 数据源
 * @param {*} childs  子集key
 */
function flattenDeep(arr: any = [], childs: string = "Children") {
    return arr.reduce((flat: any, item: any) => {
        return flat.concat(
            item,
            item[childs] ? flattenDeep(item[childs], childs) : []
        );
    }, []);
}


export default routeMatch
